import { DateRange } from '@mui/x-date-pickers-pro';
import moment from 'moment/moment';
import { useEffect, useMemo, useState } from 'react';

import { useUserActivity } from '~/data/userActivity';
import { getDateRangeWithFullDays } from '~/utils/helper';

export const useEmployeeActivityLog = (employeeId: number) => {
  const { userActivity, getUserActivity } = useUserActivity();

  const defaultRequestParams = useMemo(
    () => ({
      startDate: moment().subtract(2, 'weeks').startOf('date').toDate(),
      endDate: moment().endOf('date').toDate(),
      employees: [employeeId],
    }),
    [employeeId],
  );

  const [fetchDateRange, setFetchDateRange] = useState<DateRange<Date>>([
    defaultRequestParams.startDate,
    defaultRequestParams.endDate,
  ]);

  const onRangeChange = (dateRange: DateRange<Date | null>) => {
    const newDateRange = getDateRangeWithFullDays(dateRange);
    const [startDate, endDate] = newDateRange;

    if (startDate instanceof Date && endDate instanceof Date) {
      setFetchDateRange(newDateRange);
      getUserActivity({ ...defaultRequestParams, startDate, endDate });
    }
  };

  useEffect(() => {
    getUserActivity(defaultRequestParams);
  }, [getUserActivity, defaultRequestParams]);

  return {
    userActivity: userActivity,
    onRangeChange,
    dateRange: fetchDateRange,
  };
};
